import React, { memo, useMemo } from 'react';
import { Divider, Spacer } from '@Sage/hoi-poi-ui';
import Select from 'containers/components/Fields/Select';
import { getLiteral } from 'utils/getLiteral';
import { CompanyTextField, CompanyValueListField } from './components/fields';
import CompanyLogo from './components/CompanyLogo';

const ContentCompanyManagement = memo(({ schema, model, onChange, fieldErrors = {} }) => {
    const unitsOptions = useMemo(
        () => [
            { value: 'metric', label: getLiteral('label_metric') },
            { value: 'imperial', label: getLiteral('label_imperial') },
        ],
        [],
    );

    const renderFields = () => {
        return schema.map((section, sectionIndex) => (
            <React.Fragment key={sectionIndex}>
                {section.tabFields.map((field) => {
                    let desc, id, src;
                    if (model && schema) {
                        const idKey = typeof field.id === 'object' ? field.id.id : field.id;
                        const descKey =
                            typeof field.id === 'object' ? field.id.description : undefined;
                        id = model[idKey];
                        desc = descKey != null ? model[descKey] : undefined;
                        src = typeof field.id === 'string' ? model[field.id] : undefined;
                    }
                    switch (field.dataType) {
                        case 'singleValueList':
                            if (field.server !== 'environmentsId') {
                                return (
                                    <CompanyValueListField
                                        key={field.id?.id ?? field.id}
                                        field={field}
                                        description={field.description}
                                        desc={desc}
                                        id={id}
                                        mandatory={field.mandatory}
                                        readOnly={field.readOnly}
                                        hidden={field.hidden}
                                        tooltip={field.tooltip}
                                        onChange={onChange}
                                    />
                                );
                            }
                            return null;
                        case 'units': {
                            const unitsValue = Number(model?.units) === 1 ? 'imperial' : 'metric';
                            return (
                                <div key={field.id} className="fm-company-valuelist-field">
                                    <Select
                                        label={field.description}
                                        labelMode="horizontal"
                                        options={unitsOptions}
                                        value={unitsOptions.find((opt) => opt.value === unitsValue)}
                                        isClearable={false}
                                        onChange={(option) =>
                                            onChange(field.id, option?.value === 'imperial' ? 1 : 0)
                                        }
                                        description={
                                            field.tooltip ? getLiteral(field.tooltip) : undefined
                                        }
                                    />
                                </div>
                            );
                        }
                        case 'logo':
                            return (
                                <CompanyLogo
                                    key={field.id}
                                    field={field}
                                    type={field.type}
                                    title={field.title}
                                    description={field.description}
                                    src={src}
                                    tooltip={field.tooltip}
                                    onChange={onChange}
                                />
                            );
                        case 'hr':
                            return (
                                <>
                                    <Spacer y={3} />
                                    <Divider key={field.id} />
                                    <Spacer y={3} />
                                </>
                            );
                        case 'number':
                            return (
                                <CompanyTextField
                                    key={field.id}
                                    value={src}
                                    field={field}
                                    description={field.description}
                                    mandatory={field.mandatory}
                                    readOnly={field.readOnly}
                                    hidden={field.hidden}
                                    tooltip={field.tooltip}
                                    inputType="number"
                                    error={fieldErrors[field.id]}
                                    onChange={onChange}
                                />
                            );
                        case 'text':
                        default:
                            return (
                                <CompanyTextField
                                    key={field.id}
                                    value={src}
                                    field={field}
                                    description={field.description}
                                    mandatory={field.mandatory}
                                    readOnly={field.readOnly}
                                    hidden={field.hidden}
                                    multiLine={field.multiLine}
                                    tooltip={field.tooltip}
                                    onChange={onChange}
                                />
                            );
                    }
                })}
            </React.Fragment>
        ));
    };

    return <div>{renderFields()}</div>;
});

export default ContentCompanyManagement;
